import type { FrontifyImageContent } from '@/contentful/contentful-exports';
import { isFrontifyAsset } from '@/utils/frontify';

export const getFrontifyImage = (
  image: unknown
): FrontifyImageContent | undefined => {
  if (isFrontifyAsset(image)) {
    return image;
  }

  if (Array.isArray(image) && isFrontifyAsset(image[0])) {
    return image[0];
  }

  return undefined;
};

export const getFrontifyImages = (
  image: unknown
): FrontifyImageContent[] | undefined => {
  if (Array.isArray(image) && image.length > 0 && isFrontifyAsset(image[0])) {
    return image.filter(isFrontifyAsset);
  }

  const singleImage = getFrontifyImage(image);

  return singleImage ? [singleImage] : undefined;
};
